import { eAtlas, eUIAtlasFrame, Game } from "../../../../Game";
import { AtlasUtils } from "../../../../Utils/Atlas/AtlasUtils";
import { TIMER } from "../../../Gameplay";
import { LifeBar } from "./LifeBar";



export class LifeBarIcon {
    private _id: number;
    private _entity: pc.Entity;
    private _x: number;
    private _hideStartTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(id: number, parent: pc.Entity) {
        this._id = id;

        // Vytvorit entitu
        let atlas = Game.getAtlas(eAtlas.ui);
        let atlasRc = (atlas.frames[eUIAtlasFrame.lifeBarBallIcon] as pc.TextureAtlasFrame).rect;
        let texRc = AtlasUtils.getTexFrameRegion(atlas.texture, atlasRc);

        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: atlasRc.z,
            height: atlasRc.w,
            anchor: [0, 0.5, 0, 0.5],
            pivot: [0.5, 0.5],
            rect: texRc,
            batchGroupId: parent.element.batchGroupId
        });

        parent.addChild(this._entity);

        // Nastvit pozici
        this._x = atlasRc.z / 2 + id * LifeBar.ICON_SPACING;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.setLocalPosition(this._x, 0, 0);
        this._entity.setLocalScale(1, 1, 1);
        this._entity.setEulerAngles(0, 0, 0);
        this._entity.element.opacity = 1;
        this._entity.element.batchGroupId = (this._entity.parent as pc.Entity).element.batchGroupId;
        this._entity.enabled = true;

        this._hideStartTime = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._hideStartTime < 0)
            return false;

        let progress = (TIMER.time - this._hideStartTime) / 1000;

        if (progress >= 1) {
            this._entity.enabled = false;
            this._hideStartTime = -1;

            return false;
        }

        let cubicInProg = pc.CubicIn(progress);

        this._entity.setEulerAngles(0, 0, 360 * cubicInProg);
        this._entity.setLocalPosition(this._x, cubicInProg * -75, 0);
        this._entity.element.opacity = 1 - pc.SineIn(progress);

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    hide(): void {
        if (this._hideStartTime < 0) {
            // Zahajit mizeni ikony
            this._hideStartTime = TIMER.time;

            // Vyradit ikonu z batchgroup
            this._entity.element.batchGroupId = -1;
        }
    }
}